import { QuestionRadiogroupModel as Question } from "survey-core";
import { StringLiteral } from "typescript";

export enum OnboardingFormModuleName {
  PreQuestions = "preQuestions",
  PersonalData = "personalData",
  agencyData = "agencyData",
  careerNEmployment = "careerNEmployment",
  DocsUpload = "documentUploadModule",
  TermsNConditions = "termsNConditionsModule",
  ESignature = "eSignatureModule",
  BusinessFocus = "businessFocusModule",
  ReinstatementModule = "reinstatementModule",
}

export enum OnboardingFlow {
  Recruiter = "RECRUITER",
  Candidate = "CANDIDATE",
}

export enum OnboardingApplicationStatus {
  DRAFT = "DRAFT",
  EDITING = "EDITING",
  PENDING_SIGNATURE = "PENDING_SIGNATURE",
  SUBMITTED = "SUBMITTED",
  FOLLOW_UP_REQUIRED = "FOLLOWUP_REQUIRED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
  DELETED = "DELETED",
  CANCELLED = "CANCELLED",
}

export enum OnboardingApplicationSectionStatus {
  WARNING = "WARNING",
  COMPLETED = "COMPLETED",
}

export enum OnboardingFormSectionName {
  formPreparation = "formPreparation",
  confirmationQuestions = "confirmationQuestions",
  dataCollectionAndConsent = "dataCollectionAndConsent",
  eSignatureSection = "eSignatureSection",
  focusBusinessSection = "focusbusinessSection",
  termsNConditionsSection = "termsNConditionsSection",
  reinstateSection = "reinstateSection",
}

export enum OnboardingFormQuestionName {
  candidateSignature = "candidateSignature",
  recruiterSignature = "recruiterSignature",
  recruiterIdentityDocumentType = "recruiterIdentityDocumentType",
  recruiterIdentityDocumentUpload = "recruiterIdentityDocumentUpload",
  agentLeaderSignature = "agentLeaderSignature",
  agentLeaderDocumentType = "agentLeaderDocumentType",
  agentLeaderDocumentUpload = "agentLeaderDocumentUpload",
}

export enum RoleEnum {
  USER = "USER",
  AGENT = "AGENT",
  /**
   * Only invitations, no candidate data submitted
   */
  PENDING_CANDIDATE = "PENDING_CANDIDATE",
  CANDIDATE = "CANDIDATE",
  MANAGER = "MANAGER",
  STAFF = "STAFF",
}

export interface OnboardingFormData {
  candidateId?: string;
  templateId: string;
  moduleName?: OnboardingFormModuleName;
  applicationId?: string;
  sections?: {
    sectionName: string;
    questionAnswers: Record<string, boolean | number | string | Array<boolean | number | string>>;
  }[];
  additionalInfo?: any;
}

export interface SubmitFormActionParams {
  data: OnboardingFormData;
  action?: FormAction;
}

export enum FormAction {
  INIT = "INIT",
  REJECT = "REJECT",
  REVISE = "REVISE",
  VALIDATION = "VALIDATION",
  SAVE = "SAVE",
  SUBMIT = "SUBMIT",
  LOCK = "LOCK",
  RE_SUBMIT = "RE_SUBMIT",
  WITHDRAW = "WITHDRAW",
}
export interface OnboardingTrainingCourse {
  courseId: string;
  readonly?: boolean;
  name: string;
  type: "ONBOARDING_TRAINING";
  code: string;
  status: string;
  lessons: OnboardingLesson[];
  quiz?: OnboardingCourseQuiz;
}

export enum OnboardingLessonStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum OnboardingQuizStatus {
  DISABLED = "DISABLED",
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "IN_PROGRESS",
  PASSED = "PASSED",
  FAILED = "FAILED",
}

export enum OnboardingExamRegistryStatus {
  REGISTERED = "REGISTERED",
  FOLLOWUP_REQUIRED_REGISTERED = "FOLLOWUP_REQUIRED_REGISTERED",
  NOT_REGISTERED = "NOT_REGISTERED",
  PASSED = "PASSED",
  FAILED = "FAILED",
}

export interface OnboardingLesson {
  lessonId: string;
  name: string;
  courseName: string;
  code: string;
  materialUpload: string;
  status: OnboardingLessonStatus;
  quiz?: OnboardingQuiz;
  readonly?: boolean;
  hasNext?: boolean;
  courseQuiz?: OnboardingQuiz;
}

export interface OnboardingQuizBase {
  courseId: string;
  quizId: string;
  lessonId?: string;
  candidateId?: string;
  readonly?: boolean;
}

export interface OnboardingQuiz extends OnboardingQuizBase {
  name: string;
  status: OnboardingQuizStatus;
  type?: "COURSE_QUIZ" | "LESSON_QUIZ";
  code: string;
  score?: number;
  passingScore?: number;
  passedCount?: number;
  failedCount?: number;
  maxFailCount?: number;
  questions?: Question[];
}

type OnboardingCourseQuiz = OnboardingQuiz;

export interface Timeslot {
  name: string;
  value: string;
  remainingQuota: number;
}
export interface OnboardingRegistrationInfo {
  examCentre: string;
  examScheduleId: string;
  examDate: string;
  startTime: string;
  endTime: string;
}
export interface OnboardingExamResult {
  isPresent: boolean;
  result: "PASSED" | "FAILED";
  score: number | string;
}

// all exam registration template
export interface OnboardingTypeExam {
  type: string;
  exams: OnboardingExam[];
}

interface Summary {
  required: number;
  completed: number;
}

export interface OnboardingTrainingSummary {
  trainingSummary: Summary;
  examSummary: Summary;
}

// single exam registration template
export interface OnboardingExam {
  name: string;
  type: string;
  status: OnboardingExamRegistryStatus;
  score: number;
  id: string;
  examResult?: OnboardingExamResult;
  registeredInfo?: OnboardingRegistrationInfo;
  readonly?: boolean;
}
export interface OnboardingRegistrationData {
  examCentre: string;
  timeslot: Timeslot;
}
// candidate onboarding exam data submitted
export interface OnboardingExamData {
  name: string;
  isRegistered: boolean;
  registrationInfo?: OnboardingRegistrationData;
}

export interface CreateNPAData {
  body: CreateNPAParam;
}

export interface CreateNPAParam {
  leaderofficecode: string;
  recruiteragentcode: string;
  leadername: string;
  leaderagentcode: string;
  recruitername: string;
  idno: string;
  phoneno: string;
  paramsType: string;
  npaToken: string;
  path: string;
  dob: string;
  placeofbirth: string;
  name: string;
  recruiterofficecode: string;
  email: string;
  isPruventure: boolean;
  pruventureCity?: string | null;
  pruventureLevel?: string | null;
  pruventureExperience?: string | null;
  leaderNumberPV?: string | null;
  channel: string;
}

export interface TrainingCourseMFJ {
  question: any;
  answer: any;
}
